import React, {useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {mainActions} from '../../state/actions/main.actions';
import {useIsAuthenticated} from '../../hooks';

const SystemDataPreloader = () => {
  const dispatch = useDispatch();
  const isAuthenticated = useIsAuthenticated();
  // Categories and the permission matrix are company-scoped; a switch empties them
  // (CLEAR_COMPANY_SYSTEM_DATA), so they refetch when the company id changes.
  const companyId = useSelector(state => state.company.id);

  useEffect(() => {
    if (isAuthenticated) {
      dispatch(mainActions.getCategories());
      dispatch(mainActions.getPermissionMatrix());
    }
  }, [isAuthenticated, companyId]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
    </>
  );
};

export default SystemDataPreloader;
